/** Models */
import { DsFormTemplateSchema } from './ds-form-template-schema';
/** End Models */

/** Interfaces */
import { DsFormTemplateInterface } from '../interfaces/foms-models/ds-form-template.interface';
/** End Interfaces */

export class DsFormTemplate {
  /**
   *
   */
  name: string;

  /**
   *
   */
  id?: number;

  /**
   *
   */
  icon_id: number;

  /**
   *
   */
  category_id: number;

  /**
   *
   */
  schema: DsFormTemplateSchema;

  /**
   * Creates an instance of DsFormTemplate.
   *
   * @param template the json data
   */
  constructor(template: DsFormTemplateInterface) {
    this.name = template.name ? template.name : '';
    if (template.id) {
      this.id = template.id;
    }
    this.icon_id = template.icon_id ? template.icon_id : null;
    if (template.icon_id === 0) {
      this.icon_id = 0;
    }
    this.category_id = template.category_id ? template.category_id : null;
    this.schema = template.schema ? new DsFormTemplateSchema(template.schema) : null;
  }
}
